import { render, staticRenderFns } from "./rating-secondary.vue?vue&type=template&id=d931418a&scoped=true&"
import script from "./rating-secondary.vue?vue&type=script&lang=js&"
export * from "./rating-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d931418a",
  null
  
)

export default component.exports